import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import 'nprogress/nprogress.css';
import "./assets/style.css";
import './i18n/i18n';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import {NotificationProvider} from './components/NotificationProvider';
import ErrorBoundary from './components/ErrorBoundary';

ReactDOM.render(
  <ErrorBoundary>
    <HelmetProvider>
      <SidebarProvider>
        <BrowserRouter>
          <Provider store={store}>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </Provider>
        </BrowserRouter>
      </SidebarProvider>
    </HelmetProvider>
  </ErrorBoundary>,
  document.getElementById('root')
);

serviceWorker.unregister();
